import { MissingToken, setApiInstance } from './core';
import { retrievePlayerIamToken } from '../ReachIam';
import { getPlayerUuid, getPreviewIds } from '../Signage/utility';
import { assert } from '../Utility/assert';
import { JsonValue } from '../Utility/JsonValue';
import { LocalCacheRetrieveError, localCacheRetrieve, localCacheStore } from '../Cache';
import { Log } from '../AuxillaryService/Log';
import { NotCachedError } from './cache';

/**
 * Retrieve Player IAM token or CMS security token based on the type of player.
 *
 * @throws {@link MissingToken} if there isn't enough data to determine what
 * type of token to return (this should never happen).
 */
async function getToken(): Promise<string> {
    const playerUuid = getPlayerUuid();
    const previewIds = getPreviewIds();

    if (playerUuid) {
        return await retrievePlayerIamToken();
    } else if (previewIds) {
        return previewIds.securityToken;
    }

    throw new MissingToken('Signage does not have enough information to retrieve token.');
}

export function configureReachApiV2(): void {
    assert(typeof process.env.BASE_URL_API_V2 === 'string', 'Base URL not set.');

    setApiInstance({
        getToken,
        baseUrl: process.env.BASE_URL_API_V2,

        cacheStore: async (cacheId: string, data: JsonValue) => {
            await localCacheStore(cacheId, data, cacheId);
        },
        cacheRetrieve: async (cacheId: string) => {
            let cachedData;
            try {
                cachedData = await localCacheRetrieve(cacheId);
            } catch (err) {
                if (err instanceof LocalCacheRetrieveError) {
                    throw new NotCachedError(String(err));
                }
                throw err;
            }
            assert(!(cachedData instanceof Blob));
            return cachedData;
        },

        log: Log,
    });
}
